import { useState } from 'react';

import { Layout } from 'antd';
import cn from 'classnames';
import Image from 'next/legacy/image'
import Link from 'next/link'

import Navbar from '@components/Navbar'
import { APP_ANDROID_PATH, APP_IOS_PATH, APP_IOS_TESTFLIGHT_PATH } from '@constants/paths';
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect';
import I18n from '@utils/i18n';

import styles from '@styleModules/downLoad.module.css';

const { Header } = Layout

export default function NormalUser (props) {
  const [osName, setOsName] = useState('web');
  useIsomorphicLayoutEffect(() => {
    let res;
    if (!window.UAParser) {
      const script = document.querySelector('[data-script="ua-parser"]');
      script.addEventListener('load', () => {
        res = new window.UAParser().getResult();
        getOsName(res);
      })
      return;
    }
    res = new window.UAParser().getResult();
    getOsName(res);
  }, []);

  const getOsName = (res) => {
    const ua = res.os.name.toLocaleLowerCase();
    if (['android', 'ios'].indexOf(ua) > -1) {
      setOsName(ua);
      return;
    }
    setOsName('web');
  }

  return (
    <Layout className={styles.container}>
      <Header>
        <Navbar></Navbar>
      </Header>

      <div className={styles.content}>
        <h1 className={cn(styles.title, 'Medium')}>{I18n.t('AoaqSsmJ')}</h1>
        <div className={styles.introText}>{I18n.t('5t2arpmZ')}</div>
        <div className={styles.banner}>
          <Image
            src={require('@images/downloadPage.webp')}
            width={345}
            height={309}
            layout='responsive'
            alt={'kikitrade'}
          />
        </div>

        {osName === 'web' &&
          <>
            <div className={styles.scanImg}>
              <Image
                src={require('@images/login/qrcode.webp')}
                layout="fixed"
                width={100}
                height={100}
                alt=''
              />
            </div>
            <div className={styles.scanText}>{I18n.t('common_scan_download')}</div>
            <div className={styles.btnWrapper}>
              <Link legacyBehavior href={APP_IOS_PATH}><a target="_blank"><div className={cn(styles.btn, styles.btn1)}>App Store</div></a></Link>
              <Link legacyBehavior href={APP_ANDROID_PATH}><a target="_blank"><div className={cn(styles.btn, styles.btn2)}>Google Play</div></a></Link>
            </div>
          </>
        }
        {osName === 'ios' &&
          <div className={styles.osBtnWrapper}>
            <Link legacyBehavior href={APP_IOS_PATH}><a target="_blank"><div className={cn(styles.btn3, 'fontMedium')}>{I18n.t('gm0CTmL1')}</div></a></Link>
            <div className={styles.methodWrapper}>
              <div className={styles.method}>{I18n.t('RMbtGMgL')}</div>
            </div>
            <Link legacyBehavior href={APP_IOS_TESTFLIGHT_PATH}><a target="_blank"><div className={cn(styles.btn4, 'fontMedium')}>{I18n.t('9TikgXss')}</div></a></Link>
          </div>
        }
        {osName === 'android' &&
          <div className={styles.osBtnWrapper}>
            <Link legacyBehavior href={APP_ANDROID_PATH}><a target="_blank"><div className={cn(styles.btn3, 'fontMedium')}>{I18n.t('L2i6cIll')}</div></a></Link>
          </div>
        }
      </div>
    </Layout>
  );
}
